var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_81_98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.1796 38.33H3.57776V22.5411H57.2611V31.5118C57.2611 32.3796 57.9711 33.0896 58.8388 33.0896C59.7066 33.0896 60.4166 32.3796 60.4166 31.5118V6.75223C60.4166 3.26425 57.5879 0.435547 54.0999 0.435547H6.73892C3.25094 0.435547 0.422241 3.26425 0.422241 6.75223V54.1189C0.422241 57.6068 3.25094 60.4355 6.73892 60.4355H40.0522C40.92 60.4355 41.63 59.7256 41.63 58.8578C41.63 57.99 40.92 57.28 40.0522 57.28H6.73892C5.00338 57.28 3.5834 55.86 3.5834 54.1245V41.4911H43.1796C44.0473 41.4911 44.7573 40.7812 44.7573 39.9134C44.7573 39.0456 44.0473 38.3356 43.1796 38.3356V38.33ZM6.73892 3.59107H54.1056C55.8411 3.59107 57.2611 5.01105 57.2611 6.74659V19.3799H3.57776V6.75223C3.57776 5.01669 4.99775 3.5967 6.73329 3.5967L6.73892 3.59107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.1055 28.8579C23.2378 28.8579 22.5278 29.5679 22.5278 30.4357C22.5278 31.3034 23.2378 32.0134 24.1055 32.0134H52.5278C53.3955 32.0134 54.1055 31.3034 54.1055 30.4357C54.1055 29.5679 53.3955 28.8579 52.5278 28.8579H24.1055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.1055 13.0691H52.5278C53.3955 13.0691 54.1055 12.3591 54.1055 11.4913C54.1055 10.6236 53.3955 9.91357 52.5278 9.91357H24.1055C23.2378 9.91357 22.5278 10.6236 22.5278 11.4913C22.5278 12.3591 23.2378 13.0691 24.1055 13.0691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.10553 32.8021C10.4126 32.8021 11.4722 31.7425 11.4722 30.4355C11.4722 29.1284 10.4126 28.0688 9.10553 28.0688C7.79847 28.0688 6.73889 29.1284 6.73889 30.4355C6.73889 31.7425 7.79847 32.8021 9.10553 32.8021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17 32.8021C18.3071 32.8021 19.3666 31.7425 19.3666 30.4355C19.3666 29.1284 18.3071 28.0688 17 28.0688C15.6929 28.0688 14.6334 29.1284 14.6334 30.4355C14.6334 31.7425 15.6929 32.8021 17 32.8021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.10553 13.8519C10.4126 13.8519 11.4722 12.7924 11.4722 11.4853C11.4722 10.1782 10.4126 9.11865 9.10553 9.11865C7.79847 9.11865 6.73889 10.1782 6.73889 11.4853C6.73889 12.7924 7.79847 13.8519 9.10553 13.8519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17 13.8519C18.3071 13.8519 19.3666 12.7924 19.3666 11.4853C19.3666 10.1782 18.3071 9.11865 17 9.11865C15.6929 9.11865 14.6334 10.1782 14.6334 11.4853C14.6334 12.7924 15.6929 13.8519 17 13.8519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.10553 51.7465C10.4126 51.7465 11.4722 50.6869 11.4722 49.3798C11.4722 48.0728 10.4126 47.0132 9.10553 47.0132C7.79847 47.0132 6.73889 48.0728 6.73889 49.3798C6.73889 50.6869 7.79847 51.7465 9.10553 51.7465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17 51.7465C18.3071 51.7465 19.3666 50.6869 19.3666 49.3798C19.3666 48.0728 18.3071 47.0132 17 47.0132C15.6929 47.0132 14.6334 48.0728 14.6334 49.3798C14.6334 50.6869 15.6929 51.7465 17 51.7465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.1055 47.8022C23.2378 47.8022 22.5278 48.5122 22.5278 49.38C22.5278 50.2478 23.2378 50.9578 24.1055 50.9578H39.8944C40.7622 50.9578 41.4722 50.2478 41.4722 49.38C41.4722 48.5122 40.7622 47.8022 39.8944 47.8022H24.1055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M60.4222 44.6465V41.491C60.4222 38.003 57.5935 35.1743 54.1056 35.1743C50.6176 35.1743 47.7889 38.003 47.7889 41.491V44.6465C46.0533 44.6465 44.6334 46.0665 44.6334 47.802V57.2742C44.6334 59.0098 46.0533 60.4298 47.7889 60.4298H60.4222C62.1578 60.4298 63.5778 59.0098 63.5778 57.2742V47.802C63.5778 46.0665 62.1578 44.6465 60.4222 44.6465ZM50.9444 41.4854C50.9444 39.7498 52.3644 38.3298 54.0999 38.3298C55.8355 38.3298 57.2555 39.7498 57.2555 41.4854V44.6409H50.9388V41.4854H50.9444ZM47.7889 57.2742V47.802H60.4222V57.2742H47.7889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M54.1337 50.9575H54.1168C53.2491 50.9575 52.556 51.6675 52.556 52.5353C52.556 53.403 53.266 54.113 54.1337 54.113C55.0015 54.113 55.7115 53.403 55.7115 52.5353C55.7115 51.6675 55.0015 50.9575 54.1337 50.9575Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.1555,
    height: 60,
    fill: "white",
    transform: "translate(0.422241 0.435547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.c90a7f5eb1853c15c51b763c65a4483e.svg";
export { ForwardRef as ReactComponent };